module.exports = __webpack_public_path__ + "static/maps-7bd0045cfac94f99c4adefdb216886da.png";